<template>
    <div class="detail" v-if="currentTrack">
        <div class="detail-wrapper">
            <h3 class="detail-title">
              <span>Chart(s)</span>
              <span style="margin-left: 85%"><a href="#" id="add_more_fields" @click="add"><i class="fa fa-plus"></i></a></span>
            </h3>
             <hr>
            <div class="detail-row detail-row--2cols">
              <div class="wrapper">
                <div>
                  <div class="row" >
                    <span class=" col-sm-3" ><label style="font-size: 16px;">Country</label></span>
                    <span class=" col-sm-2" ><label style="font-size: 16px;">Charted</label></span>
                    <span class=" col-sm-2" ><label style="font-size: 16px;">Position</label></span>
                    <span class=" col-sm-2" ><label style="font-size: 16px;">Weeks</label></span>
                    <span class=" col-sm-3" ><label style="font-size: 16px;">Entry</label></span>
                  </div>
                  <br>
                  <div  v-for="(item, index) in items" :key="index">
                   <div class="row" style="margin-bottom: 15px">
                    <span class=" col-sm-3" >

                        <Dropdown v-model="item.country"  :options="countries" optionLabel="name"
                                  placeholder="Select a Country" class="w-full md:w-11rem" style="border: hidden; border-bottom: 1px solid #ced4da;">
                          <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center" >
                              <span class="flag-icon flag-icon-squared" :class="['flag-icon-' + slotProps.value.code.toLowerCase()]"></span>&nbsp;&nbsp;
                              <span>{{ slotProps.value.name }}</span>
                            </div>
                            <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                          </template>
                          <template #option="slotProps">
                            <div class="flex align-items-center">
                            <div><span class="flag-icon flag-icon-squared" :class="['flag-icon-' + slotProps.option.code.toLowerCase()]"></span>&nbsp;
                              {{ slotProps.option.name }}</div>
                            </div>
                          </template>
                        </Dropdown>
                    </span>
                    <span class=" col-sm-2" >
                      <Dropdown v-model="item.charted"  :options="chartedItems" optionLabel="name"   @change="formUpdated(item.charted , index)"
                                class="w-full md:w-5rem" style="border: hidden; border-bottom: 1px solid #ced4da;">
                          <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center" >
                              <span>{{ slotProps.value.name }}</span>
                            </div>
                            <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                          </template>
                          <template #option="slotProps">
                            <div class="flex align-items-center">
                            <div>{{ slotProps.option.name }}</div>
                            </div>
                          </template>
                        </Dropdown>
                    </span>
                    <span class=" col-sm-2" >
                      <div :class="`detail-cell${(item.charted.code ===true) && !item.position  ? ' has-error' : ''}`" style="margin-top: -17px;">
                      &nbsp; <input type="text" v-model="item.position"  size="2" v-if="item.charted.code !==false" >
                      </div>
                    </span>
                    <span class=" col-sm-2" >
                      <div :class="`detail-cell${(item.charted.code ===true) && !item.weeks  ? ' has-error' : ''}`" style="margin-top: -17px;">
                      &nbsp;  <input type="text" v-model="item.weeks"  size="2"  v-if="item.charted.code !==false" >
                   </div></span>
                     <span class=" col-sm-3" style="display: flex; ">
                        <span :class="`detail-cell${(item.charted.code ===true) && !item.entry  ? ' has-error' : ''}`" style="width: 300px;margin-top: 7px;" >
                        <Datepicker   class="date" v-model="item.entry"  size="10" :placeholder="'DD/MM/YYYY'"   format="dd/MM/yyyy" v-if="item.charted.code !==false"  />
                        </span>
                     <span :class="{'disabled_item': item.charted.code !==true}"   style="margin-top: 17px; margin-left: 0px;"> <a href="#" id="remove_fields"  @click="remove(index)"><i class="fa fa-trash"></i> </a></span>
                     </span>
                    <br>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="detail-footer">
                <div class="detail-footer-right">
                    <button class="detail-save" @click="submit">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
    import Dropdown from 'primevue/dropdown';
    import {HTTP} from "@/utils/http";
    import Datepicker from 'vuejs-datepicker';
    import moment from "moment";
    export default {
        components: {Dropdown , Datepicker},
      ...mapActions('tracks', ["loadCountiesList"]),
        computed: {
            ...mapState({

                currentTrack: state => state.tracks.currentTrack,
                currentStationUid: state => state.currentStationUid,
                jingleBoxes: (state) => {
                    if (! state.stationBoxes || ! state.stationBoxes.items) {
                        return []
                    }

                    return state.stationBoxes.items.filter(box => box.trackType === 'JINGLE')
                }
            })
        },
        data() {
            return {
              selectedCountry: null,
              moment,
              countries:[],
              count: 1,
              values: {},
              formEmpty:false,
              chartedItems:[{code: true, name:'Yes'}, {code: false, name:'No'}],
              items:[
                // {
                //   charted :{code: true, name:'Yes'},
                //   position :null,
                //   weeks :null,
                //   entry :null,
                //   country :null,
                // }
              ],
            }
        },
        mounted() {
          this.countries =this.$store.state.tracks.countries;
          this.$store.dispatch("tracks/loadCountiesList")
          const interval =  setInterval(() => {
                this.countries =this.$store.state.tracks.countries;
                if (this.countries.length > 0){
                  this.loadData();
                  clearInterval(interval)
                }

              }

              , 100);
        },

        methods: {
          makeToast(msg , type , title) {
            this.$store.dispatch('Toasts/addToast', {
              title: title,
              message: msg,
              type: type
            });
          },
          loadData(){
            console.log(this.currentTrack , this.countries)
            HTTP.get('/api/library/tracks/charts?trackUid='+ this.$route.params.trackUid)
                .then(({ data }) => {

                  const charts = data.dataItem.charts;
                 // this.items =[];
                  for (let i = 0; i < charts.length; i++) {
                    console.log(this.countries)
                    this.items.push( {
                      charted: {code: charts[i].charted, name: charts[i].charted===true  ? 'Yes' : 'No'} ,
                      position: charts[i].position ? parseInt(charts[i].position) : null,
                      weeks: charts[i].weeks ? parseInt(charts[i].weeks)  : null,
                      entry: charts[i].entry,
                      id: charts[i].id,
                      countryId : this.countries.filter(country => country.id === charts[i].countryId)[0].code,
                      country:this.countries.filter(country => country.id === charts[i].countryId)[0]
                    })
                  }
                  console.log(this.items)
                  if( charts.length === 0){
                    this.items = [
                      {
                        charted :{code: true, name:'Yes'},
                        position :null,
                        weeks :null,
                        entry :null,
                        country :null,
                      }
                    ]
                  }
                })
                .catch(error => {
                  this.errorMessage = true;
                  console.log('-------------')
                  console.log('error', error)
                })

          },
          add: function () {
            this.items.push( {
              charted :{code: true, name:'Yes'},
              position :null,
              weeks :null,
              entry :null,
              country :null,
            })
          },
          remove: function (index) {
            this.items.splice(index,1)

          },
          submit: function () {
            console.log(this.items, this.currentTrack)
            let currentItems = [];
            this.formEmpty = false;
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].charted.code ==true && (this.items[i].position === "" || this.items[i].weeks === "" || this.items[i].entry === null)) {
                console.log('this.formEmpty true' , this.items[i])
                this.formEmpty = true;
              }
              if (!this.formEmpty) {
                currentItems.push({
                  charted: this.items[i].charted.code,
                  position: this.items[i].position,
                  weeks: this.items[i].weeks,
                  id: this.items[i].id,
                  entry: this.items[i].entry!== null ? moment(this.items[i].entry).format('YYYY-MM-DD') + 'T00:00:00.000Z': null,
                  countryId: this.items[i].country.id
                })
              }
            }
            if (!this.formEmpty){
              console.log('this.formEmpty if' , currentItems)
              HTTP.post("/api/library/tracks/charts", {charts: currentItems, trackUid: this.$route.params.trackUid})
                  .then(response => {
                    console.log(response)
                    if (response.status === 200) {
                      this.makeToast('Charts updated success', 'success', 'Success')
                    } else {
                      this.makeToast('Failed to update Charts', 'danger', 'Error')
                    }
                  }).catch(error => {
                // this.makeToast('Failed to load data', 'danger' ,'Error');
                this.spinner = false;
              })
          }
          },
          formUpdated(item , index){
            console.log(item , index)
            if (item.code === false) {
              this.items[index].position = null;
              this.items[index].weeks = null;
              this.items[index].entry = null;
            }
          }
        },
        watch: {
          "items": function (val) {
              console.log(val)
          },
          "countries": function (val) {
            console.log('------------------------------------------------------------------')
            console.log(val)
          }
        }
    }
</script>
<style lang="scss" scoped>
.vdp-datepicker {
 // width: 170%!important;
}
.trash {
  margin-right: 180%!important;
}
.date{
  border: hidden;
  max-width: 300px;
  border-bottom: 1px solid #ced4da;
}
.disabled_item{
  margin-left: 128px!important;
}

.label{
  font-size: 16px;
}
.detail {
  padding: 25px 25px 40px;
}

.detail-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 1040px;
}
.wrapper{
  padding: 25px 25px 40px;
  max-width: 1000px;
}

.detail-title {
  color: #292C33;
  font-size: 16px;
  line-height: 1;

  &:not(:first-child) {
    margin-top: 40px;
  }

  + .detail-row {
    margin-top: 20px;
  }
}

.detail-row {

  &:first-child {
    margin-top: 0;
  }

  &--2cols {
    .detail-cell {
      width: 50%;
    }
  }

  &--3cols {
    .detail-cell {
      width: 33.33%;

      &--big {
        width: 66.66%;
      }
    }
  }
}

.detail-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 15px;

  &.has-error {
    .detail-error {
      display: block;
    }
  }
}

.detail-label {
  display: block;
  transition: transform .3s ease-in-out;
  color: #696B70;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: .2px;
  line-height: calc(16 / 13);

  i {
    margin-left: 5px;
    color: #ABACAF;
    font-style: italic;
  }
}

.detail-value {
  margin-top: 8px;
  display: block;
  color: #292C33;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: .2px;
  line-height: calc(17 / 14);
}

.detail-error {
  display: none;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #f00;
}

// Footer
// -----------------------------------------------------------------------------
.detail-footer {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  position: relative;
  width: 100%;
  margin-top: 20px;
  padding-top: 25px;
  border-top: 1px solid #d2d2d2;

  button {
    text-transform: uppercase;
  }
}

.detail-footer-right {
  display: flex;
  align-items: center;
  margin-left: auto;

  .m-loader + .detail-button {
    opacity: .5;
    pointer-events: none;
  }

  .detail-button {
    margin-left: 20px;
  }
}

.detail-footer-loader {
  color: #696B70;
  font-size: 14px;
  margin-right: 10px;
}

.detail-link {
  padding: 0;
  border: 0;
  border-radius: 0;
  transition: color .2s ease-in-out;
  background-color: transparent;
  color: #ABACAF;
}

// Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

// Inputs
.field {
  color: #696B70;
  display: flex;
  flex-direction: column;
  // padding-top: 3px;
  position: relative;
  width: 100%;

  &.inline {
    height: 24px;
    padding-top: 0;
    line-height: 16px;

    .input {
      height: 24px;
    }

    input {
      font-size: 13px;
    }

  }
}

.append, .prepend {
  font-size: 13px;
}

label {
  display: block;
  font-weight: 300;
  font-size: 11px;
  transition: all .15s ease-out;
  margin-bottom: 0;

  span {
    color: #ABACAF;
    font-style: italic;
  }
}

.field.error {
  label {
    color: #FE6B5B;
  }

  .message {
    color: #FE6B5B;
  }
}

.message {
  text-align: right;
  font-size: 13px;
  line-height: 20px;
}
.pi-chevron-down{
  font-size: 15px;
}
.select {
  background: #ffffff;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 3px;
  width: 4.2rem !important;
  height: 2.45rem !important;
  border: hidden;
  border-bottom: 1px solid #ced4da;

  &::placeholder {
    color: #ccc;
  }
}

.focused:not(.readonly) {
  &:not(.empty) {
    label {
      color: var(--color-brand);
    }
  }
}
.has-error{
  border-color: red;
}
.error {
  color: #FE6B5B;
}
</style>
